import controller from '../product-filter.controller'
import template from './product-filter.html'

export default {
  template,
  controller
}
